module.exports = __webpack_public_path__ + "img/9.9679341b.png";